import { useProcurifyIntl } from '@webapp/hooks'
import { type PunchOutStatus, PunchOutStatuses } from '@webapp/models/enums'
import messages from './messages'

export function useFormatPunchOutStatus() {
  const intl = useProcurifyIntl()

  return (status: PunchOutStatus): string => {
    switch (status) {
      case PunchOutStatuses.ORDER_CANCELLED:
        return intl.formatMessage(messages.punchOutOrderCancelled)
      case PunchOutStatuses.PARTIALLY_PURCHASED:
        return intl.formatMessage(messages.punchOutPartiallyPurchased)
      case PunchOutStatuses.BACKORDERED:
        return intl.formatMessage(messages.punchOutBackordered)
      default:
        return
    }
  }
}
